import { LegacyVisibilityModel, ColumnVisibilityModelsType } from './columns/shared/column-types';
import { validateView } from './columns/shared/column-utils';
import { Views } from './columns/views';
import { buildVisibilityModel, getByViewTab, getByMappingName } from './columns/legacy/columnVisibilityAdapter';

const ColumnVisibilityModels: ColumnVisibilityModelsType = {} as ColumnVisibilityModelsType;

Object.entries(Views).forEach(([viewName, viewModel]) => {
  try {
    validateView(viewModel);
    ColumnVisibilityModels[viewName] = buildVisibilityModel(viewModel);
  } catch (error) {
    throw error;
  }
});

ColumnVisibilityModels['numberPmidsWithChemsIncludedInEvidenceGDA_EVIDENCE'] =
  ColumnVisibilityModels['GDA_ALL_EVIDENCE'];
ColumnVisibilityModels['numberPmidsWithChemsIncludedInEvidenceVDA_EVIDENCE'] =
  ColumnVisibilityModels['VDA_ALL_EVIDENCE'];
ColumnVisibilityModels['numPMIDsupportingAssociationGDA_EVIDENCE'] =
  ColumnVisibilityModels['GDA_ALL_EVIDENCE'];
ColumnVisibilityModels['numPMIDsupportingAssociationVDA_EVIDENCE'] =
  ColumnVisibilityModels['VDA_ALL_EVIDENCE'];

Object.defineProperty(ColumnVisibilityModels, 'getByViewTab', {
  value: function (VIEW: string, TAB: string, isEvidence: boolean): LegacyVisibilityModel | undefined {
    return getByViewTab(this, VIEW, TAB, isEvidence);
  },
  enumerable: false,
});

Object.defineProperty(ColumnVisibilityModels, 'getByMappingName', {
  value: function (mappingName: string, isEvidence: boolean): LegacyVisibilityModel | undefined {
    return getByMappingName(this, mappingName, isEvidence);
  },
  enumerable: false,
});

export { ColumnVisibilityModels, Views };
export { buildVisibilityModel } from './columns/legacy/columnVisibilityAdapter';
export { validateView } from './columns/shared/column-utils';
export type { ColumnViewModel, LegacyVisibilityModel, ColumnVisibilityModelsType } from './columns/shared/column-types';